import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getCurrentDate, getPastDate } from "../utils/formatTime";

// Get the current date
const currentDate = new Date();

// Calculate the start date (180 days ago)
const startDate = new Date(currentDate);
startDate.setDate(currentDate.getDate() - 180);

// Format the dates in YYYY-MM-DD format (you can change the format as needed)
const formattedStartDate = startDate.toISOString().split("T")[0];
const formattedEndDate = currentDate.toISOString().split("T")[0];

const initialuserActivityDataSearch = {
  facilityID: 0,
  requestFormTypeID: 0,
  reqCurrentStatus: 2,
  requestCreateStartDate: getPastDate(6),
  requestCreateEndDate: getCurrentDate(),
  inmateFirstNames: "",
  inmateLastNames: "",
  inmateFirstNameId: 0,
  inmateLastNameId: 0,
  inmateId: "",
  managementUserID: 0,
  responseManagementUserID: 0,
  pageNo: 1,
  rowCountPerPage: 10,
  sortBy: "",
};

const initialreqActivityDataSearch = {
  FacilityID: 0,
  RequestFormTypeID: 0,
  reqCurrentStatus: 2,
  InmateFirstNames: "",
  InmateLastNames: "",
  InmateId: "",
  ResponseManagementUserID: 0,
  RequestCreateStartDate: getPastDate(6),
  RequestCreateEndDate: getCurrentDate(),
  mangementUserID: 0,
  PageNo: 1,
  RowCountPerPage: 10,
  SortBy: "",
};

const tabName = {
  currentTabName: "ManagementUser",
  requestform: false,
};

// create slice
const name = "Reporting";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const reportingAction = { ...slice.actions, ...extraActions };
export const reportingReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    userActivityDataSearch: initialuserActivityDataSearch,
    reqActivityDataSearch: initialreqActivityDataSearch,
    getRequestFormPermissionManagementUser: [],
    getRequestFormUsernameDropdown: [],
    getManagementUserRequestFormPermission: [],
    LoadManagementUserFormReportList: [],
    LoadManagementUserFormReportFullList: [],
    LoadManagementRequestActiveFormPermission: [],
    LoadManagementUserPermissionFormReportList: [],
    GetManagementRequestFormDropDown: [],
    LoadRequestFormTypeResponseTimePercentageList: [],
    LoadRequestFormTypeResponseTimeDetails: [],
    LoadRequestFormTypeResponseTimeDetailsPopup: [],
    GetLoadReportingInmateRequestVisitorInfoList: [],
    GetReportingInmateRequestForumThreadPostList: [],
    tabActiveHistory: tabName,
    TimeDetailsloading: false,
    FormReportListloading: false,
    TimePercentageListloading: false,
    RequestVisitorInfoListLoading: false,
    TimeDetailsPopuploading: false,
    loading: false,
  };
}

function createReducers() {
  return {
    setTabActive,
    resetTabActive,
    setreqActivityDataSearch,
    resetreqActivityDataSearch,
    setuserActivityDataSearch,
    resetuserActivityDataSearch,
    clearResponseTimePercentageListFullList,
  };

  function setuserActivityDataSearch(state, action) {
    state.userActivityDataSearch = action && action.payload;
  }

  function resetuserActivityDataSearch(state) {
    state.userActivityDataSearch = initialuserActivityDataSearch;
  }

  // ///////////////////////////////////////////

  function setreqActivityDataSearch(state, action) {
    state.reqActivityDataSearch = action && action.payload;
  }

  function resetreqActivityDataSearch(state) {
    state.reqActivityDataSearch = initialreqActivityDataSearch;
  }

  function setTabActive(state, action) {
    state.tabActiveHistory = action.payload;
  }
  function resetTabActive(state) {
    state.tabActiveHistory = tabName;
  }
  function clearResponseTimePercentageListFullList(state) {
    state.ResponseTimePercentageListFullList = [];
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/Reporting`;

  return {
    GetRequestFormPermissionManagementUser:
      GetRequestFormPermissionManagementUser(),
    GetManagementUserRequestFormPermission:
      GetManagementUserRequestFormPermission(),
    LoadManagementUserFormReportList: LoadManagementUserFormReportList(),
    LoadManagementRequestActiveFormPermission:
      LoadManagementRequestActiveFormPermission(),
    LoadManagementUserPermissionFormReportList:
      LoadManagementUserPermissionFormReportList(),
    GetManagementRequestFormDropDown: GetManagementRequestFormDropDown(),
    LoadRequestFormTypeResponseTimePercentageList:
      LoadRequestFormTypeResponseTimePercentageList(),
    LoadRequestFormTypeResponseTimeDetailsPopup:
      LoadRequestFormTypeResponseTimeDetailsPopup(),
    LoadRequestFormTypeResponseTimeDetails:
      LoadRequestFormTypeResponseTimeDetails(),
    GetLoadReportingInmateRequestVisitorInfoList:
      GetLoadReportingInmateRequestVisitorInfoList(),
    GetReportingInmateRequestForumThreadPostList:
      GetReportingInmateRequestForumThreadPostList(),
    GetRequestFormSearchUsernameDropdown:
      GetRequestFormSearchUsernameDropdown(),
  };

  function GetRequestFormPermissionManagementUser() {
    return createAsyncThunk(
      `${name}/GetRequestFormPermissionManagementUser`,
      async (facilityID) =>
        await fetchWrapper.get(
          `${baseUrl}/GetRequestFormPermissionManagementUser?facilityID=${facilityID}`
        )
    );
  }
  function GetRequestFormSearchUsernameDropdown() {
    return createAsyncThunk(
      `${name}/GetRequestFormSearchUsernameDropdown`,
      async (facilityID) =>
        await fetchWrapper.get(
          `${baseUrl}/GetRequestFormSearchUsernameDropdown?facilityID=${facilityID}`
        )
    );
  }

  function GetManagementUserRequestFormPermission() {
    return createAsyncThunk(
      `${name}/GetManagementUserRequestFormPermission`,
      async (facilityID) =>
        await fetchWrapper.get(
          `${baseUrl}/GetManagementUserRequestFormPermission?facilityID=${facilityID}`
        )
    );
  }
  function LoadManagementUserFormReportList() {
    return createAsyncThunk(
      `${name}/LoadManagementUserFormReportList`,
      async (params) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadManagementUserFormReportList`,
          params
        )
    );
  }

  function LoadManagementRequestActiveFormPermission() {
    return createAsyncThunk(
      `${name}/LoadManagementRequestActiveFormPermission`,
      async ({ mangementUserID, PageNo, RowCountPerPage }) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadManagementRequestActiveFormPermissionList?mangementUserID=${mangementUserID}&PageNo=${PageNo}&RowCountPerPage=${RowCountPerPage}`
        )
    );
  }

  function GetManagementRequestFormDropDown() {
    return createAsyncThunk(
      `${name}/GetManagementRequestFormDropDown`,
      async ({ mangementUserID, facilityID }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetManagementRequestFormDropDown?mangementUserID=${mangementUserID}&facilityID=${facilityID}`
        )
    );
  }

  function LoadManagementUserPermissionFormReportList() {
    return createAsyncThunk(
      `${name}/LoadManagementUserPermissionFormReportList`,
      async (params) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadManagementUserPermissionFormReportList`,
          params
        )
    );
  }

  function LoadRequestFormTypeResponseTimePercentageList() {
    return createAsyncThunk(
      `${name}/LoadRequestFormTypeResponseTimePercentageList`,
      async (params) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadRequestFormTypeResponseTimePercentageList`,
          params
        )
    );
  }
  function LoadRequestFormTypeResponseTimeDetails() {
    return createAsyncThunk(
      `${name}/LoadRequestFormTypeResponseTimeDetails`,
      async (params) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadRequestFormTypeResponseTimeDetails`,
          params
        )
    );
  }
  function LoadRequestFormTypeResponseTimeDetailsPopup() {
    return createAsyncThunk(
      `${name}/LoadRequestFormTypeResponseTimeDetailsPopup`,
      async (params) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadRequestFormTypeResponseTimeDetails`,
          params
        )
    );
  }

  function GetLoadReportingInmateRequestVisitorInfoList() {
    return createAsyncThunk(
      `${name}/GetLoadReportingInmateRequestVisitorInfoList`,
      async ({ RequestVisitorFormID, PageNo, RowCountPerPage }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetLoadReportingInmateRequestVisitorInfoList?requestVisitorFormID=${RequestVisitorFormID}&PageNo=${PageNo}&RowCountPerPage=${RowCountPerPage}`
        )
    );
  }

  function GetReportingInmateRequestForumThreadPostList() {
    return createAsyncThunk(
      `${name}/GetReportingInmateRequestForumThreadPostList`,
      async ({
        RequestForumThreadID,
        IsInmate,
        IsManagementUser,
        PageNo,
        RowCountPerPage,
      }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetReportingInmateRequestForumThreadPostList?requestForumThreadID=${RequestForumThreadID}&isInmate=${IsInmate}&isManagementUser=${IsManagementUser}&PageNo=${PageNo}&RowCountPerPage=${RowCountPerPage}`
        )
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(
      extraActions.GetRequestFormPermissionManagementUser.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetRequestFormPermissionManagementUser.fulfilled,
      (state, action) => {
        state.getRequestFormPermissionManagementUser = action.payload;
        state.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetRequestFormPermissionManagementUser.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }
    )
    .addCase(
      extraActions.GetRequestFormSearchUsernameDropdown.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetRequestFormSearchUsernameDropdown.fulfilled,
      (state, action) => {
        state.getRequestFormUsernameDropdown = action.payload;
        state.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetRequestFormSearchUsernameDropdown.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }
    )

    .addCase(
      extraActions.GetManagementUserRequestFormPermission.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetManagementUserRequestFormPermission.fulfilled,
      (state, action) => {
        state.getManagementUserRequestFormPermission = action.payload;
        state.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetManagementUserRequestFormPermission.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }
    )

    .addCase(extraActions.LoadManagementUserFormReportList.pending, (state) => {
      state.FormReportListloading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadManagementUserFormReportList.fulfilled,
      (state, action) => {
        const params = action.meta.arg;
        if (params?.exportExcel) {
          state.LoadManagementUserFormReportFullList = action?.payload;
        } else {
          state.LoadManagementUserFormReportList = action.payload;
        }
        state.FormReportListloading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadManagementUserFormReportList.rejected,
      (state, action) => {
        state.FormReportListloading = false;
        state.error = action.error.message;
      }
    )

    .addCase(
      extraActions.LoadManagementRequestActiveFormPermission.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadManagementRequestActiveFormPermission.fulfilled,
      (state, action) => {
        state.LoadManagementRequestActiveFormPermission = action.payload;
        state.LoadManagementRequestActiveFormPermission.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadManagementRequestActiveFormPermission.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }
    )

    .addCase(
      extraActions.LoadManagementUserPermissionFormReportList.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadManagementUserPermissionFormReportList.fulfilled,
      (state, action) => {
        state.LoadManagementUserPermissionFormReportList = action.payload;
        state.LoadManagementUserPermissionFormReportList.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadManagementUserPermissionFormReportList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }
    )

    // get form title in requst form activity tab

    .addCase(extraActions.GetManagementRequestFormDropDown.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetManagementRequestFormDropDown.fulfilled,
      (state, action) => {
        state.GetManagementRequestFormDropDown = action.payload;
        state.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetManagementRequestFormDropDown.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }
    )

    // grid list for request form activity tab

    .addCase(
      extraActions.LoadRequestFormTypeResponseTimePercentageList.pending,
      (state) => {
        state.TimePercentageListloading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadRequestFormTypeResponseTimePercentageList.fulfilled,
      (state, action) => {
        const params = action.meta.arg;
        if (params?.exportExcel) {
          state.ResponseTimePercentageListFullList = action?.payload;
        } else {
          state.LoadRequestFormTypeResponseTimePercentageList = action.payload;
        }
        state.TimePercentageListloading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadRequestFormTypeResponseTimePercentageList.rejected,
      (state, action) => {
        state.TimePercentageListloading = false;
        state.error = action.error.message;
      }
    )

    // grid list form search
    .addCase(
      extraActions.LoadRequestFormTypeResponseTimeDetails.pending,
      (state) => {
        state.TimeDetailsloading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadRequestFormTypeResponseTimeDetails.fulfilled,
      (state, action) => {
        const params = action.meta.arg;
        if (params?.exportExcel) {
          state.FormTypeResponseTimeDetailsFullList = action?.payload;
          state.TimeDetailsloading = false;
        } else {
          state.LoadRequestFormTypeResponseTimeDetails = action?.payload;
          state.TimeDetailsloading = false;
        }

        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadRequestFormTypeResponseTimeDetails.rejected,
      (state, action) => {
        state.TimeDetailsloading = false;
        state.error = action.error.message;
      }
    )

    // Form Title – Grid click (Form Type Selected value =1)

    .addCase(
      extraActions.GetLoadReportingInmateRequestVisitorInfoList.pending,
      (state) => {
        state.RequestVisitorInfoListLoading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetLoadReportingInmateRequestVisitorInfoList.fulfilled,
      (state, action) => {
        const params = action.meta.arg;
        if (params?.exportExcel) {
          state.RequestVisitorInfoListFullList = action?.payload;
          state.RequestVisitorInfoListLoading = false;
        } else {
          state.GetLoadReportingInmateRequestVisitorInfoList = action?.payload;
          state.RequestVisitorInfoListLoading = false;
        }

        state.error = null;
      }
    )
    .addCase(
      extraActions.GetLoadReportingInmateRequestVisitorInfoList.rejected,
      (state, action) => {
        state.RequestVisitorInfoListLoading = false;
        state.error = action.error.message;
      }
    )

    // grid list form search
    .addCase(
      extraActions.LoadRequestFormTypeResponseTimeDetailsPopup.pending,
      (state) => {
        state.TimeDetailsPopuploading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadRequestFormTypeResponseTimeDetailsPopup.fulfilled,
      (state, action) => {
        state.LoadRequestFormTypeResponseTimeDetailsPopup = action?.payload;
        state.TimeDetailsPopuploading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadRequestFormTypeResponseTimeDetailsPopup.rejected,
      (state, action) => {
        state.TimeDetailsPopuploading = false;
        state.error = action.error.message;
      }
    )

    // grid list GetReporting InmateRequest Forum Thread PostList
    .addCase(
      extraActions.GetReportingInmateRequestForumThreadPostList.pending,
      (state) => {
        state.ThreadPostListloading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetReportingInmateRequestForumThreadPostList.fulfilled,
      (state, action) => {
        state.GetReportingInmateRequestForumThreadPostList = action?.payload;
        state.ThreadPostListloading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetReportingInmateRequestForumThreadPostList.rejected,
      (state, action) => {
        state.ThreadPostListloading = false;
        state.error = action.error.message;
      }
    );
}
